import { render } from "./categoriesView.vue?vue&type=template&id=b9954662&scoped=true"
import script from "./categoriesView.vue?vue&type=script&lang=js"
export * from "./categoriesView.vue?vue&type=script&lang=js"

import "./categoriesView.vue?vue&type=style&index=0&id=b9954662&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9954662"]])

export default __exports__